// removed by extract-text-webpack-plugin
module.exports = {"card":"card-3wBb0"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/cards/styles.scss
 ** module id = 17
 ** module chunks = 0
 **/